import axios from 'axios'
import moment from 'moment'
import store from '@/store'
import router from '@/router'
import { SESSION_HEADERS, SESSION_EXPIRES_TIME_VALUE, SESSION_EXPIRES_TIME_UNIT } from 'utils/constants'
import { isValidObject } from 'corp-front-vue-commons/src/utils/functions'

// modules
import session from './modules/session'
import company from './modules/company'
import costCenter from './modules/costCenter'
import employee from './modules/employee'
import reports from './modules/reports'
import project from './modules/project'
import accounts from './modules/accounts'
import webcall from './modules/webcall'
import wallet from './modules/wallet'
import companyGroup from './modules/companyGroup'
import timePolicy from './modules/timePolicy'
import requestApiToken from './modules/requestApiToken'

function getHeaders (headers) {
  if (isValidObject(headers) && headers.authorization) {
    const localStorageData = JSON.stringify({ authorization: headers.authorization })
    const sessionExpiresDate = moment().add(SESSION_EXPIRES_TIME_VALUE, SESSION_EXPIRES_TIME_UNIT).format()

    localStorage.setItem(SESSION_HEADERS, localStorageData)
    store.dispatch('sessionExpiresTime/set', sessionExpiresDate)
  }
}

function setHeaders (config) {
  const session = JSON.parse(localStorage.getItem(SESSION_HEADERS))

  if (isValidObject(session) && session.authorization) {
    config.headers.authorization = session.authorization
  }
}

function isInvalidSession (error) {
  return !error ||
    error.message === 'Network Error' ||
    (
      error && error.response &&
      (error.response.status === 401 || error.response.status === 500)
    )
}

export const loginPath = () => {
  return 'b2b-iam-app/authentication'
}

export const legacyV2Path = () => {
  return process.env.NODE_ENV === 'production'
    ? 'b2b-legacy'
    : 'b2b-legacy-staging'
}

export const legacyV3Path = () => {
  return process.env.NODE_ENV === 'production'
    ? 'b2b-legacy-v3'
    : 'b2b-legacy-v3-staging'
}

export const b2bReportKey = () => {
  return process.env.NODE_ENV === 'production'
    ? 'sW1KE3aDhQXapa65PrNNvCcb8bwNO8O7bihfxjJv'
    : 'zVJ3afOtJ1fz57TbXEnCIlX8unP74RYnB11JvMJN'
}

export const apiInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 40000,
  withCredentials: true
})

const apiService = {
  session: { ...session },
  company: { ...company },
  costCenter: { ...costCenter },
  employee: { ...employee },
  reports: { ...reports },
  project: { ...project },
  accounts: { ...accounts },
  webcall: { ...webcall },
  wallet: { ...wallet },
  companyGroup: { ...companyGroup },
  timePolicy: { ...timePolicy },
  requestApiToken: { ...requestApiToken }
}

apiInstance.interceptors.request.use(function (config) {
  setHeaders(config)
  return config
}, function (error) {
  return Promise.reject(error)
})

apiInstance.interceptors.response.use(function (response) {
  getHeaders(response.headers)
  return response
}, function (error) {
  if (isInvalidSession(error)) {
    session.logout()
    router.push({ name: 'Login' }).catch(e => {})
  }
  return Promise.reject(error)
})

export default {
  install (Vue) {
    Vue.$apiService = apiService
    Vue.prototype.$apiService = apiService
  }
}
